import React from "react";
import "../Health/HealthBanner.css";
import { motion } from "framer-motion";
import bgImage from "../../Assets/educational/eduban1.png";

const EducationalBanner = () => {
  return (
    <section className="health-banner">
      {/* Animated Background Image Reveal */}
      <motion.img
        src={bgImage}
        alt="Background"
        className="bg-image"
        initial={{ scale: 1.2, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
      />

      <div className="banner-content">
        {/* Left content reveal */}
        <motion.div
          className="left-content"
          initial={{ x: -80, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <motion.div
            className="text-box"
            initial={{ y: 40, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5, duration: 1, ease: "easeOut" }}
          >
            <h2>
              Transforming Lives through <br />
              <motion.span
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.7, duration: 1 }}
              >
                Knowledge and Care.
              </motion.span>
            </h2>
            <p>
              VCNR Education Trust is dedicated to creating educational opportunities that empower 
              individuals and communities. The trust encompasses multiple initiatives, including 
              Hithachinthana School and our Nursing College, ensuring access to quality education, 
              skill-building, and professional development.
            </p>

            <motion.button
              className="explore-btn1"
              onClick={() => window.open("https://www.hithachinthana.org", "_blank")}
              initial={{ scale: 0.9, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              transition={{ delay: 1, duration: 0.8 }}
            >
              Explore More
            </motion.button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default EducationalBanner;
